export enum AnalyticsEventEnum {
  SIGN_IN = 'signIn',
  SIGN_UP_PHONE_SET = 'signUpPhoneSet',
  SIGN_UP_PHONE_CONFIRM = 'signUpPhoneConfirm',
  SIGN_UP_PASSWORD_SET = 'signUpPasswordSet',
  SIGN_UP_INFO_SET = 'signUpInfoSet',
  PLATFORM_ADD_TO_ORDER_DRAFT = 'platformAddToOrderDraft',
  CREATE_CONFIRM_ORDER = 'createConfirmOrder',
  CLICK_DEPOSIT = 'clickDeposit',
}
